<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.create" | translate}} {{"intelligence-reporting.questions.question" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendCreationRequest()" [formGroup]="questionCreateForm" autocomplete="off">
      <div class="form-container">

        <mat-form-field appearance="fill">
          <mat-label>{{"intelligence-reporting.questions.short-code" |translate}}</mat-label>
          <input [formControl]="shortCodeControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.dialogs.description" |translate}}</mat-label>
          <input [formControl]="descriptionControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"intelligence-reporting.questions.label" |translate}}</mat-label>
          <input [formControl]="labelControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.templates.category" |translate}}</mat-label>
          <mat-select [formControl]="categoryControl">
            <mat-option *ngFor="let category of data" [value]="category.id">{{category.description}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox [formControl]="yearlyControl">{{"intelligence-reporting.questions.yearly" | translate}}</mat-checkbox>

        <mat-radio-group [formControl]="questionTypeControl">
          <mat-radio-button *ngFor="let qt of questionTypes" [value]="qt.value">{{qt.description}}</mat-radio-button>
        </mat-radio-group>

        <mat-checkbox [formControl]="atAGlanceInfoControl">{{"intelligence-reporting.questions.at-a-glance" | translate}} {{"intelligence-reporting.questions.info" | translate}}</mat-checkbox>

        <mat-checkbox [formControl]="sharingLevelLockedControl">{{"intelligence-reporting.questions.sharing-level" | translate}} {{"intelligence-reporting.questions.locked" | translate}}</mat-checkbox>

        <mat-form-field appearance="fill">
          <mat-label>{{"intelligence-reporting.questions.sharing-level" |translate}}</mat-label>
          <mat-select [formControl]="sharingLevelControl">
            <mat-option *ngFor="let sl of sharingLevel" [value]="sl.value">{{sl.description}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"intelligence-reporting.questions.kind-of" |translate}} {{"intelligence-reporting.questions.answer" |translate}}</mat-label>
          <mat-select [formControl]="answerTypeControl">
            <mat-option *ngFor="let at of answerTypes" [value]="at.value">{{at.description}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="answerTypeControl.value === 'TEXT'">
          <mat-label>{{"intelligence-reporting.questions.max" |translate}} {{"intelligence-reporting.questions.length" |translate}}</mat-label>
          <input [formControl]="maxLengthControl" matInput type="number">
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="answerTypeControl.value === 'NUMBER'">
          <mat-label>{{"intelligence-reporting.questions.min" |translate}} {{"intelligence-reporting.questions.value" |translate}}</mat-label>
          <input [formControl]="minValueControl" (change)="setMaxValueMinimumLimit()" matInput type="number">
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="answerTypeControl.value === 'NUMBER'">
          <mat-label>{{"intelligence-reporting.questions.max" |translate}} {{"intelligence-reporting.questions.value" |translate}}</mat-label>
          <input [formControl]="maxValueControl" matInput type="number">
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="answerTypeControl.value === 'LIST'">
          <mat-label>{{"intelligence-reporting.questions.available" |translate}} {{"intelligence-reporting.questions.answer" |translate}}</mat-label>
          <textarea [formControl]="availableAnswersControl" matInput type="number"></textarea>
        </mat-form-field>

        <mat-checkbox *ngIf="answerTypeControl.value === 'LIST'" [formControl]="multiSelectControl">{{"intelligence-reporting.questions.allow" | translate}} {{"intelligence-reporting.questions.multiple-selection" | translate}}</mat-checkbox>

        <mat-checkbox [formControl]="mandatoryControl">{{"intelligence-reporting.questions.mandatory" | translate}}</mat-checkbox>

        <mat-form-field appearance="fill">
          <mat-label>{{"intelligence-reporting.questions.info" |translate}} {{"intelligence-reporting.questions.text" |translate}}</mat-label>
          <textarea [formControl]="commentControl" matInput type="text"></textarea>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Include in chart</mat-label>
          <mat-select [formControl]="chartControl">
            <mat-option [value]="null">-</mat-option>
            <mat-option *ngFor="let chart of charts" [value]="chart.value">{{chart.description}}</mat-option>
          </mat-select>
        </mat-form-field>


        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="questionCreateForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
